import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface GateChange {
  id: string;
  flight_number: string;
  airline: string;
  old_gate: string | null;
  new_gate: string | null;
  departure_time: string;
  detected_at: string;
}

export const useGateChanges = (airportCode: string) => {
  const [gateChanges, setGateChanges] = useState<GateChange[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!airportCode) return;

    const fetchGateChanges = async () => {
      try {
        // Get gate changes from the last 6 hours
        const sixHoursAgo = new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString();

        const { data, error } = await supabase
          .from("gate_changes" as any)
          .select("*")
          .eq("airport_code", airportCode.toUpperCase())
          .gte("detected_at", sixHoursAgo)
          .order("detected_at", { ascending: false });

        if (error) throw error;
        setGateChanges((data as any) || []);
      } catch (err) {
        console.error("Error fetching gate changes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGateChanges();
  }, [airportCode]);

  const getGateChangeForFlight = (flightNumber: string): GateChange | undefined => {
    return gateChanges.find((gc) => gc.flight_number === flightNumber);
  };

  return { gateChanges, loading, getGateChangeForFlight };
};
